<div
  class="frame-title"
  [style.background-color]="inputTemplate.color"
  fxLayout="row"
  *ngIf="inputTemplate.main_title"
>
  <mat-icon [ngStyle]="{ color: '#6d008b' }">{{
    inputTemplate.main_icon
  }}</mat-icon>
  <div class="text-1 left-middle">
    <span> {{ inputTemplate.main_title }} </span>
  </div>
</div>

<div
  class="frame-content"
  [style.background-color]="inputTemplate.color"
  *ngIf="has_values"
>
  <div *ngIf="inputTemplate.title" class="text-2">
    <span> {{ inputTemplate.title }} </span>
  </div>

  <div fxLayout="row">
    <div fxFlex="50">
      <div
        [style.margin]="'0.5em 1em 0.5em 0em'"
        fxLayoutAlign="space-around center"
        *ngFor="
          let info of inputTemplate.info_list | slice: 0:limit_1;
          let i = index
        "
      >
        <div fxFlex="55" class="info-label">
          <span>
            {{ info.descriptor_name }}
          </span>
        </div>
        <div fxFlex="45" class="info-value">
          <span>
            {{ info.value }}
          </span>
        </div>
      </div>
    </div>
    <div fxFlex="50">
      <div
        [style.margin]="'0.5em 0em 0.5em 1em'"
        fxLayoutAlign="space-around center"
        *ngFor="
          let info of inputTemplate.info_list | slice: limit_1:limit_2;
          let i = index
        "
      >
        <div fxFlex="55" class="info-label">
          <span>
            {{ info.descriptor_name }}
          </span>
        </div>
        <div fxFlex="45" class="info-value">
          <span>
            {{ info.value }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
